import { gspx } from '@rsos/gainsight';
import { DARK_THEME } from '@rsos/theme/constants';

export const trackThemeControlClicks = (mode, irpVersion) => {
  const themeStatus = mode === DARK_THEME ? 'on' : 'off';
  gspx.trackCustomEvent('Navigation', {
    irpVersion,
    name: `Click turn ${themeStatus} night mode`,
    Category: 'Navigation',
    'Launched date': new Date(),
  });
};
